import { UsageLimit } from "@pages/settings/subscription-settings/usage-limit";
import { selectStorageUsedSelector } from "@store/sdb-company/sdb-company-selector";
import { useAppSelector } from "@store/store-helper";
import { formatStorageSize, getStorageUnit } from "@utils/ui-utils";

/**
 * Displays the storage usage for the current company
 * Shows the current usage for all workspaces, which available in storage property of the company context
 * Shows the max usage only if company has an active subscription, which available in quotas property of the company context
 * Max usage in quotas only available which workspace has an active subscription
 */
export function StorageUsage(): JSX.Element | undefined {
  const selectStorageUsed = useAppSelector(selectStorageUsedSelector);

  if (!selectStorageUsed) {
    return undefined;
  }

  const storageUsed = selectStorageUsed.used;
  const storageLimit = selectStorageUsed.max;
  const maxToDisplay = storageLimit
    ? formatStorageSize(storageLimit)
    : undefined;

  const percentage = storageLimit
    ? (storageUsed / storageLimit) * 100
    : undefined;

  return (
    <UsageLimit
      percentage={percentage}
      current={formatStorageSize(storageUsed)}
      max={maxToDisplay}
      currentUnit={getStorageUnit(storageUsed)}
      maxUnit={getStorageUnit(storageLimit)}
      decimalPlaces={2}
    />
  );
}
